import { useOutletContext } from 'react-router';
import { LandingPage } from '../r5/LandingPage';

export function HomePage() {
  const { onSignUp } = useOutletContext<{ onSignUp?: () => void }>();
  return <LandingPage onSignUp={onSignUp} />;
}
